import { render, staticRenderFns } from "./widget-link.vue?vue&type=template&id=8a6cf1c2&scoped=true"
import script from "./widget-link.vue?vue&type=script&lang=ts"
export * from "./widget-link.vue?vue&type=script&lang=ts"
import style0 from "./widget-link.vue?vue&type=style&index=0&id=8a6cf1c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6cf1c2",
  null
  
)

export default component.exports